export const getFirstLetterString = (string) => string?.charAt(0)?.toUpperCase();
